import { render, staticRenderFns } from "./addOrgaManagerRoot.vue?vue&type=template&id=9dc7288c&scoped=true"
import script from "./addOrgaManagerRoot.vue?vue&type=script&lang=js"
export * from "./addOrgaManagerRoot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dc7288c",
  null
  
)

export default component.exports